import * as React from "react";

const Check: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M14 2.5H13.0624V1H11.75V2.5H5.75V1H4.50009V2.5H3.5C2.675 2.5 2 3.175 2 4V14.5C2 14.8978 2.15804 15.2794 2.43934 15.5607C2.72064 15.842 3.10218 16 3.5 16H14C14.8325 16 15.5 15.3325 15.5 14.5V4C15.5 3.60218 15.342 3.22064 15.0607 2.93934C14.7794 2.65804 14.3978 2.5 14 2.5ZM14.25 14.75H3.25V7H14.25V14.75ZM3.25 5.75V3.75H14.25V5.75H3.25ZM7.67 13.345L12.125 8.8975L11.3225 8.1025L7.67 11.755L6.0875 10.1725L5.2925 10.9675L7.67 13.345Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(Check);
